import React from 'react'
import { component } from 'hoc'
import PropTypes from 'prop-types'
import Img from 'components/img'
import Button from 'components/button'
import styles from './unauthorized.styles'

const Unauthorized = ({ classes, messages }) =>
  (
    <div className={classes.main}>
      <div className={classes.container}>
        <div className={classes.logoContainer}>
          <Img className="logo-sparklane" src="/img/logo-sparklane.png" />
          <span className={classes.sloganSparklane}>{messages.slogan}</span>
        </div>
        <div className={classes.infoContainer}>
          <span className={classes.text}>{messages.info}</span>
          <Button type="primary" name="LOGOUT" className={classes.logout}>{messages.logout}</Button>
        </div>
      </div>
    </div>
  )


Unauthorized.propTypes = {
  classes: PropTypes.object,
  messages: PropTypes.object,

}

Unauthorized.defaultProps = {
  classes: {},
  messages: {},
}

export default component({ styles })(Unauthorized)
